async function getPosts() {
  try {
    const res = await fetch(
      "https://graph.facebook.com/v19.0/17841448049372007?fields=followers_count%2Cbiography%2Cprofile_picture_url%2Cusername%2Cwebsite%2Cmedia%7Bcaption%2Ccomments_count%2Clike_count%2Cmedia_type%2Cmedia_url%2Cpermalink%2Cthumbnail_url%2Ctimestamp%2Ccomments%7D&access_token=EAAESLvZC9ApgBOzVbHIw4cHZB40OvAdX4ueDkykIYpASyo7NcgrHZAiYRKs0llQn1yES829mvtZCzp6UvaPf1H470Ob5SBlJP65CeapoB5LMF4qqFaLKZBx1L9M35f5NZAMEf8bWiOYaxEHQ0gPtoKdwHOnHMAlYf1ZAKSONsX1fjctaVMjsCRu7aE6yAyGu4dNLgVmjoex"
    );

    if (!res.ok) {
      throw new Error("Could not fetch resource");
    }

    const data = await res.json();
    const posts = data.media.data;
    const screenWidth = window.innerWidth;
    const postNo = screenWidth > 992 ? 10 : 9;
    //console.log(posts);

    const layoutContainer = document.querySelector(".layout-container");

    for (let i = 0; i < postNo && i < posts.length; i++) {
      const post = posts[i];

      const postContainer = document.createElement("div");
      postContainer.classList.add("post-box");
      postContainer.classList.add("scroll-trigger");
      postContainer.classList.add("animate--slide-in");

      if (!post.media_url) {
        const imageElement = document.createElement("img");
        imageElement.classList.add("post");
        imageElement.src = post.thumbnail_url;
        imageElement.alt = post.thumbnail_url;
        imageElement.loading = "lazy";

        postContainer.appendChild(imageElement);
        layoutContainer.appendChild(postContainer);
      } else if (post.media_url.includes(".mp4")) {
       const imageElement = document.createElement("img");
        imageElement.classList.add("post");
        imageElement.src = post.thumbnail_url;
        imageElement.alt = post.thumbnail_url;
        imageElement.loading = "lazy";

        postContainer.appendChild(imageElement);
        layoutContainer.appendChild(postContainer);
      } else {
        const imageElement = document.createElement("img");
        imageElement.classList.add("post");
        imageElement.src = post.media_url;
        imageElement.alt = post.media_url;
        imageElement.loading = "lazy";
        imageElement.height="auto"
        imageElement.width="auto"

        postContainer.appendChild(imageElement);
        layoutContainer.appendChild(postContainer);
      }

      postContainer.addEventListener("click", () => {
        showModal(post); // Pass the posts variable
      });
    }
  } catch (error) {
    console.log(error);
  }
}

const modalEl = document.querySelector(".modal-section");

document.addEventListener("DOMContentLoaded", function () {
  getPosts();

  // Event listener for closing the modal
  const modalCloseBtn = document.querySelector(".close-btn");

  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeModal();
    }
  });

  // Event listener for popstate event
  window.addEventListener("popstate", handlePopState);
});

function showModal(post) {
  const dateString = post.timestamp.toString();

  // Parse the date string into a Date object
  const date = new Date(dateString);

  // Array of month names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Get the month, day, and year
  const month = monthNames[date.getMonth()];
  const day = date.getDate();
  const year = date.getFullYear();

  // Format the date
  const formattedDate = month + " " + day + ", " + year;
  modalEl.classList.add("active");
  const modalContainer = document.querySelector(".modal-pic-container");
  const postLink = document.querySelector(".post-link");
  const descContainer = document.querySelector(".post-desc");
  const postDate = document.querySelector(".post-date");
  if (!post.media_url) {
    modalContainer.innerHTML = `<img class="img-post" loading="lazy" alt="post" src="${post.thumbnail_url}">`;
  } else if (post.media_url.includes(".mp4")) {
    modalContainer.innerHTML = `<video class="modal-post-video" muted autoplay><source src="${post.media_url}" type="video/mp4"></video>`;
  } else {
    modalContainer.innerHTML = `<img loading="lazy" class="img-post" alt="post" src="${post.media_url}">`;
  }

  if (post.caption) {
    descContainer.innerHTML = `<p>${post.caption}</p>`;
  }

  if (post.permalink) {
    postLink.href = post.permalink;
  }

  if (post.timestamp) {
    postDate.textContent = formattedDate;
  }
}

modalEl.addEventListener("click", (e) => {
  if (e.target === modalEl) {
    closeModal();
  }
});

function closeModal() {
  const modalEl = document.querySelector(".modal-section");
  const modalContent = modalEl.querySelector(".modal-post");
  modalEl.classList.remove("active");

  // Remove any existing content
  modalContent.innerHTML = "";

  // Remove index from URL
  const newUrl = window.location.pathname;
  history.replaceState(null, "", newUrl);
}

// Event listener for closing the modal

function handlePopState(event) {
  const index = event.state ? event.state.index : null;
  if (index !== null) {
    const posts = JSON.parse(sessionStorage.getItem("posts"));
    showModal(index, posts);
  } else {
    closeModal();
  }
}

// Event listener for popstate event
window.addEventListener("popstate", handlePopState);

const buttons = document.querySelectorAll('.modal-close');
buttons.forEach(button => button.addEventListener('click', closeModal));
